import React, { useEffect } from 'react';

import logger from 'utils/logger.util';

import EditDetails from 'clientProfile/components/BasicProfile/EditDetailsContainer';

const L = logger('AddNewClient');

const AddNewClient = ({
  clientTags,
  createNewClient,
  fetchSalonTagsList,
  history,
  location,
  match,
  newClient,
  pickClient,
  salonId,
  salonTags,
  saveLocalTags,
}) => {
  useEffect(
    () => void L.unignore('useEffect()', 'fetchSalonTagsList:', fetchSalonTagsList({ salonId })),
    [fetchSalonTagsList, salonId],
  );
  return (
    <div className="BookingWindow">
      <EditDetails
        clientTags={clientTags}
        createNewClient={createNewClient}
        isFetching={newClient.isFetching}
        history={history}
        location={location}
        match={match}
        new
        newClient={newClient}
        pickClient={pickClient}
        salonId={salonId}
        salonTags={salonTags}
        saveLocalTags={saveLocalTags}
      />
    </div>
  );
};

export default AddNewClient;
